<template>
  <div>
    <!-- subscribable & answers -->
    <div class="ms-4 py-1 m-2 condition-border">
      <!-- subscribable -->
      <select
        v-model="select"
        class="form-control form-select"
        aria-label="Default select example"
        @change="changePropertyValue(selectorPropertyConstant.subscribable)"
      >
        <template
          v-for="(value, propertyName) in subscribables"
        >
          <option
            :key="propertyName"
            :value="propertyName"
          >
            {{ value }}
          </option>
        </template>
      </select>
    </div>
    <!-- state -->
    <div
      class="d-flex py-1 px-3 mx-2"
    >
      <template v-if="selector.state">
        <div class="d-flex flex-column flex-grow-1">
          <div class="fw-bold px-2">
            {{ trans('subscription.classification_config.selectors.subscribable.subscribe_state') }}
          </div>
          <SelectorSelectOperator
            v-model="selector.state"
            :selector-type="'subscribable'"
            :operator-type="selectorStateOperatorConstant"
            @change="changeOperatorSelectorStateType"
          />
        </div>
        <div class="d-flex align-items-center ms-3">
          <RuleSmallButton
            :disabled="isLoading"
            class="btn-danger p-2 small-button-width fw-bold mx-2"
            :title="'-'"
            @click.native="removeState(weight)"
          />
        </div>
      </template>
      <template v-else>
        <RuleSmallButton
          :title="trans('subscription.classification_config.selectors.subscribable.add_state')"
          type="button"
          class="btn-secondary my-3"
          @click.native="addState()"
        />
      </template>
    </div>
    <!-- answers -->
    <template v-if="selector.answers">
      <div
        class="d-flex align-items-center py-1 ps-3 state-background"
      >
        <div class="fw-bold px-2">
          {{ trans('subscription.classification_config.selectors.subscribable.anwers') }}
        </div>
        <SelectorSelectOperator
          v-model="selector.answer_operator"
          :selector-type="'subscribable'"
          @change="changeOperatorSelectorAnswerType"
        />
        <div
          class="d-flex flex-row-reverse flex-grow-1 me-3"
        >
          <button
            class="focus-style fw-bold"
            type="button"
            @click="removeAnwers()"
          >
            X
          </button>
        </div>
      </div>
      <MultiSelectComponent
        v-if="!isLoading"
        id="anwersSelector"
        v-model="currentArray"
        class="mb-2 my-1"
        :max-selected-options="500"
        :label="trans('subscription.classification_config.selectors.subscribable.select_anwers')"
        :type="'question-template-answer'"
        track-by="name"
        @input="changeSelectedValues"
      />
      <Loader
        v-else
        class="pb-3"
      />
    </template>
    <template v-else>
      <RuleSmallButton
        :title="trans('subscription.classification_config.selectors.subscribable.add_anwers')"
        type="button"
        class="btn-secondary ms-3 my-3 "
        @click.native="addAnwers()"
      />
    </template>
  </div>
</template>

<script>
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import selectorMixin from '@/employees/components/Selector/utilities/mixins/selectorMixin'
import { OPERATOR_TYPE, SELECTOR_PROPERTY, STATE_OPERATOR_TYPE } from '@/constants'
import { mapState } from 'vuex'
export default {
  name: 'SelectorSubscribable',
  components: { MultiSelectComponent },
  mixins: [selectorMixin],
  props: {
    selectorReference: {
      required: true,
      type: String,
    },
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      select: null,
      opertorTypeConstant: OPERATOR_TYPE,
      selectorPropertyConstant: SELECTOR_PROPERTY,
      selectorStateOperatorConstant: STATE_OPERATOR_TYPE,
      isLoading: false,
      currentArray: [],
    }
  },
  computed: {
    ...mapState({
      subscribables (state) {
        return state.selectors.subscribables
      },
      // #region anwsers
      missingAnswerIds (state) {
        return this.objectMissingIds(state.questionTemplates.questionTemplateAnswers, this.selector.answers)
      },
      answers (state) {
        return this.selector.answers.map((id) => {
          if (!state.questionTemplates.questionTemplateAnswers.hasOwnProperty(id)) {
            return {}
          }
          const questionTemplateAnswer = state.questionTemplates.questionTemplateAnswers[id]
          const questionTemplate = state.questionTemplates.questionTemplates[questionTemplateAnswer.questionTemplate]
          return {
            id: id,
            name: `${questionTemplate.name} / ${questionTemplateAnswer.answer}`,
          }
        })
      },
      // #endregion
    }),
  },
  mounted () {
    if (this.selector.subscribable) {
      this.select = this.selector.subscribable
    }
    this.isLoading = true
    if (this.selector.answers) {
      if (this.missingAnswerIds.length > 0) {
        this.$store.dispatch('getQuestionTemplateAnwsers', {
          queryParams: {
            filter: {
              id: this.missingAnswerIds,
            },
            include: ['questionTemplate.answers.questionTemplate'],
          },
        }).then(() => { this.currentArray = this.answers })
      }
      this.currentArray = this.answers
    }
    this.isLoading = false
  },
  methods: {
    // #region subscriable
    changePropertyValue (selectorPropertyEnum) {
      this.selectorPropertyValueChange(this.selectorReference, selectorPropertyEnum, Number(this.select))
    },
    // #endregion
    // #region state
    changeOperatorSelectorStateType (newValue) {
      this.$root.$emit('SelectorOperatorChange', [this.selectorReference, newValue, undefined])
    },
    removeState () {
      this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.state, undefined)
    },
    addState () {
      this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.state, this.selectorStateOperatorConstant.subscribed)
    },
    // #endregion
    // #region anwers
    addAnwers () {
      this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.answers, [])
      this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.answer_operator, this.opertorTypeConstant.or)
    },
    removeAnwers () {
      this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.answers, undefined)
      this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.answer_operator, undefined)
    },
    objectMissingIds (object, idArray) {
      const missingIds = []
      for (let i = 0; i < idArray.length; i++) {
        if (!object.hasOwnProperty(idArray[i])) {
          missingIds.push(idArray[i])
        }
      }
      return missingIds
    },
    changeSelectedValues (newValue) {
      const newValueArray = newValue.map(row => row.id)
      if (newValue.length !== this.selector.answers.length || this.arraysNotEqual(newValueArray, this.selector.answers)) {
        this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.answers, newValueArray)
      }
    },
    arraysNotEqual (array1, array2) {
      return array1.sort().join(',') !== array2.sort().join(',')
    },
    changeOperatorSelectorAnswerType (newValue) {
      this.$root.$emit('SelectorOperatorChange', [this.selectorReference, newValue, undefined])
    },
    // #endregion
  },
}
</script>

<style lang="scss" scoped>
/deep/
.form-control {
  width: auto;
}
.state-background {
  background-color: rgba(0, 0, 0, 0.3);
}
.focus-style {
  border-style: hidden;
  background: none;
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
/deep/
.col-sm-2 {
  float: none;
}
/deep/
.col-sm-10 {
  float: none;
}
</style>
